import { render } from "./PracticePlanTemplate.vue?vue&type=template&id=5e076522&scoped=true"
import script from "./PracticePlanTemplate.vue?vue&type=script&lang=js"
export * from "./PracticePlanTemplate.vue?vue&type=script&lang=js"

import "./PracticePlanTemplate.vue?vue&type=style&index=0&id=5e076522&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e076522"]])

export default __exports__